// generated with @7nohe/openapi-react-query-codegen@1.6.2
import {
  AskForQuotationService,
  DownloadsService,
  EasyService,
  HealthService,
  ImportService,
  LineItemApiService,
  NeedHelpService,
  QuoteApiService,
  StatusApiService,
  TestService,
} from "../requests/services.gen";
import {
  ConvertTokenInput,
  MailRequest,
  NeedHelp,
  ReturnedString,
  VM3PQToEasySynchronization,
  VMAskForQuotation,
  VMAskForQuotationEmail,
  VMImportLineItem,
  VMInitiateSessionFromWebsite,
  VMIsLoggedIn,
  VMLineItemInformation,
  VMLineItemList,
  VMQuotesPost,
  WegTestCallInput,
} from "../requests/types.gen";

import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";

import * as Common from "./common";

export const useDownloadsServiceGetApiDownloadsDownloadDataSheet = <
  TData = Common.DownloadsServiceGetApiDownloadsDownloadDataSheetDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    country,
    language,
    materialNumber,
  }: {
    country?: string;
    language?: string;
    materialNumber?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDownloadsServiceGetApiDownloadsDownloadDataSheetKeyFn(
      { country, language, materialNumber },
      queryKey,
    ),
    queryFn: () =>
      DownloadsService.getApiDownloadsDownloadDataSheet({
        country,
        language,
        materialNumber,
      }) as TData,
    ...options,
  });
export const useEasyServiceGetApiEasyCheckLoginState = <
  TData = Common.EasyServiceGetApiEasyCheckLoginStateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEasyServiceGetApiEasyCheckLoginStateKeyFn(queryKey),
    queryFn: () => EasyService.getApiEasyCheckLoginState() as TData,
    ...options,
  });
export const useEasyServiceGetApiEasyAdministrationArea = <
  TData = Common.EasyServiceGetApiEasyAdministrationAreaDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEasyServiceGetApiEasyAdministrationAreaKeyFn(queryKey),
    queryFn: () => EasyService.getApiEasyAdministrationArea() as TData,
    ...options,
  });
export const useEasyServiceGetApiEasyAdministrationAreaCountryList = <
  TData = Common.EasyServiceGetApiEasyAdministrationAreaCountryListDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEasyServiceGetApiEasyAdministrationAreaCountryListKeyFn(
        queryKey,
      ),
    queryFn: () =>
      EasyService.getApiEasyAdministrationAreaCountryList() as TData,
    ...options,
  });
export const useEasyServiceGetApiEasyCountry = <
  TData = Common.EasyServiceGetApiEasyCountryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEasyServiceGetApiEasyCountryKeyFn(queryKey),
    queryFn: () => EasyService.getApiEasyCountry() as TData,
    ...options,
  });
export const useHealthServiceGetApiHealthDatabaseCleanupWithCpq = <
  TData = Common.HealthServiceGetApiHealthDatabaseCleanupWithCpqDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseHealthServiceGetApiHealthDatabaseCleanupWithCpqKeyFn(queryKey),
    queryFn: () => HealthService.getApiHealthDatabaseCleanupWithCpq() as TData,
    ...options,
  });
export const useLineItemApiServiceGetApiLineItemApiLineItemProperties = <
  TData = Common.LineItemApiServiceGetApiLineItemApiLineItemPropertiesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    lineItemId,
  }: {
    lineItemId?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseLineItemApiServiceGetApiLineItemApiLineItemPropertiesKeyFn(
        { lineItemId },
        queryKey,
      ),
    queryFn: () =>
      LineItemApiService.getApiLineItemApiLineItemProperties({
        lineItemId,
      }) as TData,
    ...options,
  });
export const useQuoteApiServiceGetPreviewApi3PqCpqV1Quotes = <
  TData = Common.QuoteApiServiceGetPreviewApi3PqCpqV1QuotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseQuoteApiServiceGetPreviewApi3PqCpqV1QuotesKeyFn(queryKey),
    queryFn: () => QuoteApiService.getPreviewApi3PqCpqV1Quotes() as TData,
    ...options,
  });
export const useQuoteApiServiceGetPreviewApi3PqCpqV1QuotesById = <
  TData = Common.QuoteApiServiceGetPreviewApi3PqCpqV1QuotesByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    id,
  }: {
    id: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQuoteApiServiceGetPreviewApi3PqCpqV1QuotesByIdKeyFn(
      { id },
      queryKey,
    ),
    queryFn: () =>
      QuoteApiService.getPreviewApi3PqCpqV1QuotesById({ id }) as TData,
    ...options,
  });
export const useQuoteApiServiceGetApiQuoteApiGetQuoteId = <
  TData = Common.QuoteApiServiceGetApiQuoteApiGetQuoteIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQuoteApiServiceGetApiQuoteApiGetQuoteIdKeyFn(queryKey),
    queryFn: () => QuoteApiService.getApiQuoteApiGetQuoteId() as TData,
    ...options,
  });
export const useQuoteApiServiceGetApiQuoteApiConvertSessionFromEasyById = <
  TData = Common.QuoteApiServiceGetApiQuoteApiConvertSessionFromEasyByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    id,
  }: {
    id: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseQuoteApiServiceGetApiQuoteApiConvertSessionFromEasyByIdKeyFn(
        { id },
        queryKey,
      ),
    queryFn: () =>
      QuoteApiService.getApiQuoteApiConvertSessionFromEasyById({ id }) as TData,
    ...options,
  });
export const useQuoteApiServiceGetApiQuoteApiLanguage = <
  TData = Common.QuoteApiServiceGetApiQuoteApiLanguageDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQuoteApiServiceGetApiQuoteApiLanguageKeyFn(queryKey),
    queryFn: () => QuoteApiService.getApiQuoteApiLanguage() as TData,
    ...options,
  });
export const useStatusApiServiceGetPreviewApi3PqCpqV1StatusById = <
  TData = Common.StatusApiServiceGetPreviewApi3PqCpqV1StatusByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    filter,
    id,
    includes,
    order,
    size,
    sort,
    start,
  }: {
    filter?: string;
    id: string;
    includes?: string;
    order?: string;
    size?: number;
    sort?: string;
    start?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStatusApiServiceGetPreviewApi3PqCpqV1StatusByIdKeyFn(
      { filter, id, includes, order, size, sort, start },
      queryKey,
    ),
    queryFn: () =>
      StatusApiService.getPreviewApi3PqCpqV1StatusById({
        filter,
        id,
        includes,
        order,
        size,
        sort,
        start,
      }) as TData,
    ...options,
  });
export const useTestServiceGetApiTest = <
  TData = Common.TestServiceGetApiTestDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestKeyFn(queryKey),
    queryFn: () => TestService.getApiTest() as TData,
    ...options,
  });
export const useTestServiceGetApiTestJwTtoken = <
  TData = Common.TestServiceGetApiTestJwTtokenDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestJwTtokenKeyFn(queryKey),
    queryFn: () => TestService.getApiTestJwTtoken() as TData,
    ...options,
  });
export const useTestServiceGetApiTestJwTtoken2 = <
  TData = Common.TestServiceGetApiTestJwTtoken2DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestJwTtoken2KeyFn(queryKey),
    queryFn: () => TestService.getApiTestJwTtoken2() as TData,
    ...options,
  });
export const useTestServiceGetApiTestName = <
  TData = Common.TestServiceGetApiTestNameDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestNameKeyFn(queryKey),
    queryFn: () => TestService.getApiTestName() as TData,
    ...options,
  });
export const useTestServiceGetApiTestEasyToken = <
  TData = Common.TestServiceGetApiTestEasyTokenDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestEasyTokenKeyFn(queryKey),
    queryFn: () => TestService.getApiTestEasyToken() as TData,
    ...options,
  });
export const useTestServiceGetApiTestJumpToEasy = <
  TData = Common.TestServiceGetApiTestJumpToEasyDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestJumpToEasyKeyFn(queryKey),
    queryFn: () => TestService.getApiTestJumpToEasy() as TData,
    ...options,
  });
export const useTestServiceGetApiTestGetMockSession = <
  TData = Common.TestServiceGetApiTestGetMockSessionDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTestServiceGetApiTestGetMockSessionKeyFn(queryKey),
    queryFn: () => TestService.getApiTestGetMockSession() as TData,
    ...options,
  });
export const useAskForQuotationServicePostApiAskForQuotationAskForQuotationEmail =
  <
    TData = Common.AskForQuotationServicePostApiAskForQuotationAskForQuotationEmailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: VMAskForQuotationEmail;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: VMAskForQuotationEmail;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AskForQuotationService.postApiAskForQuotationAskForQuotationEmail({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
export const useAskForQuotationServicePostApiAskForQuotationSendAskForQuotationEmail =
  <
    TData = Common.AskForQuotationServicePostApiAskForQuotationSendAskForQuotationEmailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: VMAskForQuotation;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: VMAskForQuotation;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AskForQuotationService.postApiAskForQuotationSendAskForQuotationEmail({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
export const useEasyServicePostApiEasyRedirectToEasy = <
  TData = Common.EasyServicePostApiEasyRedirectToEasyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: VMLineItemList;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: VMLineItemList;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EasyService.postApiEasyRedirectToEasy({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useEasyServicePostApiEasySessionFromEasy = <
  TData = Common.EasyServicePostApiEasySessionFromEasyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: VM3PQToEasySynchronization;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: VM3PQToEasySynchronization;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EasyService.postApiEasySessionFromEasy({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useEasyServicePostApiEasySessionFromWegWebsite = <
  TData = Common.EasyServicePostApiEasySessionFromWegWebsiteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: VMInitiateSessionFromWebsite;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: VMInitiateSessionFromWebsite;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EasyService.postApiEasySessionFromWegWebsite({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useHealthServicePostApiHealthKeepalive = <
  TData = Common.HealthServicePostApiHealthKeepaliveMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: VMIsLoggedIn;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: VMIsLoggedIn;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      HealthService.postApiHealthKeepalive({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useImportServicePostApiImportImportLineitem = <
  TData = Common.ImportServicePostApiImportImportLineitemMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: VMImportLineItem;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: VMImportLineItem;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ImportService.postApiImportImportLineitem({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useNeedHelpServicePostApiNeedHelpNeedHelp = <
  TData = Common.NeedHelpServicePostApiNeedHelpNeedHelpMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: NeedHelp;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: NeedHelp;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NeedHelpService.postApiNeedHelpNeedHelp({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useQuoteApiServicePostPreviewApi3PqCpqV1Quotes = <
  TData = Common.QuoteApiServicePostPreviewApi3PqCpqV1QuotesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: VMQuotesPost;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: VMQuotesPost;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      QuoteApiService.postPreviewApi3PqCpqV1Quotes({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useTestServicePostApiTestConvertToSingleUseToken = <
  TData = Common.TestServicePostApiTestConvertToSingleUseTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: ConvertTokenInput;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: ConvertTokenInput;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TestService.postApiTestConvertToSingleUseToken({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useTestServicePostApiTestWegTestCall = <
  TData = Common.TestServicePostApiTestWegTestCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: WegTestCallInput;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: WegTestCallInput;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TestService.postApiTestWegTestCall({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useTestServicePostApiTestMockEasySynchronization = <
  TData = Common.TestServicePostApiTestMockEasySynchronizationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: string[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TestService.postApiTestMockEasySynchronization({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useTestServicePostApiTestTestEmail = <
  TData = Common.TestServicePostApiTestTestEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: MailRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: MailRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TestService.postApiTestTestEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useTestServicePostApiTestTest = <
  TData = Common.TestServicePostApiTestTestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: string[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TestService.postApiTestTest({ requestBody }) as unknown as Promise<TData>,
    ...options,
  });
export const useEasyServicePutApiEasyAdministrationArea = <
  TData = Common.EasyServicePutApiEasyAdministrationAreaMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: ReturnedString;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: ReturnedString;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EasyService.putApiEasyAdministrationArea({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useLineItemApiServicePutApiLineItemApiLineItemProperties = <
  TData = Common.LineItemApiServicePutApiLineItemApiLineItemPropertiesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        lineItemId?: string;
        requestBody?: VMLineItemInformation;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      lineItemId?: string;
      requestBody?: VMLineItemInformation;
    },
    TContext
  >({
    mutationFn: ({ lineItemId, requestBody }) =>
      LineItemApiService.putApiLineItemApiLineItemProperties({
        lineItemId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
export const useQuoteApiServicePutApiQuoteApiLanguage = <
  TData = Common.QuoteApiServicePutApiQuoteApiLanguageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      QuoteApiService.putApiQuoteApiLanguage({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
